<template>
	<div class="integration_container" :class="{ show_switches: showSwitches }">
		<v-row no-gutters class="integration mt-4">
			<v-col cols="12">
				<div class="block_app blk">
					<AppInfo @showSelectAppScreen="showSelectAppScreen" />
				</div>
				<div class="block_action blk">
					<AppAction />
				</div>
				<transition name="fromBottomLight" mode="out-in">
					<div class="block_profile blk" v-if="showProfileSection">
						<ProfileSelector
							:profileId="editNode.credentials_configuration.credentials"
							:serviceId="editNode.service"
							:serviceVersionId="editNode.service_version"
							@select-profile="selectProfile"
							:disableRealProfiles="editWorkflowHasInstallable"
						/>
					</div>
				</transition>
			</v-col>
		</v-row>
		<div class="bottom_actions">
			<v-row no-gutters>
				<v-col cols="12" class="my-1">
					<v-divider></v-divider>
					<v-row no-gutters class="mt-3" align="end">
						<v-col cols="9" class="text-left">
							<v-btn
								text
								height="25"
								width="192"
								@click="showSwitches = !showSwitches"
								color="#5E7288"
								style="font-weight: 500 !important; text-transform: none !important; font-size: 14px !important; color: #5e7288 !important"
							>
								show advanced settings <v-icon class="pl-2">mdi-chevron-{{ showSwitches ? 'up' : 'down' }}</v-icon>
							</v-btn>
							<!-- <transition name="testInTransition"> -->
							<div v-if="showSwitches" class="mt-2">
								<v-switch inset dense color="white" hide-details v-model="asyncRunAfterAllPrevious" class="swtch drk mr-n3 sml">
									<template v-slot:label>
										<v-row no-gutters class="fill-height" align-content="center">
											<v-col cols="auto">
												<span> Run after previous steps </span>
											</v-col>
											<v-col offset="auto" class="pl-3">
												<SIcon name="iasync-down" title="Run after previous steps" style="position: relative; transform: scale(0.8)" />
											</v-col>
										</v-row>
									</template>
								</v-switch>
								<br />
								<v-switch inset dense color="white" hide-details v-model="asyncRunBeforeAllFollowing" class="swtch drk sml mr-n3">
									<template v-slot:label>
										<v-row no-gutters class="fill-height" align-content="center">
											<v-col cols="auto">
												<span> Run before next steps </span>
											</v-col>
											<v-col offset="auto" class="pl-3">
												<SIcon name="iasync-up" title="Run before next steps" style="position: relative; transform: scale(0.8)" />
											</v-col>
										</v-row>
									</template>
								</v-switch>
							</div>
							<!-- </transition> -->
						</v-col>
						<v-col class="text-right">
							<v-btn
								outlined
								color="#5E7288"
								height="24"
								width="80"
								style="
									color: #5e7288 !important;
									font-size: 12px !important;
									border: 1px solid #d1d9e9;
									font-weight: 500;
									border-radius: 0px !important;
								"
								@click="deleteStep"
								>Delete step</v-btn
							>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import AppInfo from './BlockEditorIntegrationApp';
import AppAction from './BlockEditorIntegrationAction';
import { mapActions, mapGetters } from 'vuex';
import AppService from '@/utils/AppService';
import { setParamInEditNode } from '@/store/modules/selectedNode/actions';
import { deleteNode } from '@/store/modules/selectedWorkflow/actions';
import { editWorkflowHasInstallable } from '@/store/modules/selectedWorkflow/getters';
import ProfileSelector from '@/components/common/ProfileSelector';
import { PER_USER_CONNECTION_ID, VIRTUAL_PROFILES_IDS } from '@/utils/credentials-service.const';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { CredentialsTypes } from '@ply-io/ply-front-shared-utilities';

export default {
	name: 'BlockEditorIntegration',
	props: {},
	data() {
		return {
			showSwitches: false,
		};
	},
	mounted() {},
	components: {
		AppInfo,
		AppAction,
		ProfileSelector,
		// SIcon
	},
	watch: {},
	computed: {
		...mapGetters('selectedNode', ['editNode']),
		...mapGetters(['apps/getService', editWorkflowHasInstallable.fullPath]),
		editWorkflowHasInstallable() {
			return this[editWorkflowHasInstallable.fullPath];
		},
		showProfileSection() {
			return this.editNode.action && AppService.doesRequiresAuth(this.selectedApp);
		},
		selectedApp() {
			return this['apps/getService'](this.editNode.service) || {};
		},
		asyncRunAfterAllPrevious: {
			get() {
				return this.editNode.async_run_after_all_previous_flag;
			},
			set(value) {
				this[setParamInEditNode.fullPath]({ key: 'async_run_after_all_previous_flag', value });
			},
		},
		asyncRunBeforeAllFollowing: {
			get() {
				return this.editNode.async_before_all_following_flag;
			},
			set(value) {
				this[setParamInEditNode.fullPath]({ key: 'async_before_all_following_flag', value });
			},
		},
	},
	methods: {
		...mapActions([deleteNode.fullPath, setParamInEditNode.fullPath]),
		showSelectAppScreen() {
			this.$emit('showSelectAppScreen');
		},
		deleteStep() {
			AppDialogManagerService.openDeleteBlockDialog({ block: this.editNode });
		},
		selectProfile(credsId) {
			if (VIRTUAL_PROFILES_IDS.includes(credsId)) {
				const credentialsType = credsId === PER_USER_CONNECTION_ID ? CredentialsTypes.ProfileBased : CredentialsTypes.AccountBased;
				// this[setParamInEditNode.fullPath]({ key: 'credentials', value: null });
				this[setParamInEditNode.fullPath]({ key: 'credentials_type', value: credentialsType });
			} else {
				this[setParamInEditNode.fullPath]({ key: 'credentials', value: credsId });
				this[setParamInEditNode.fullPath]({ key: 'credentials_type', value: CredentialsTypes.Embedded });
			}
		},
	},
};
</script>

<style scoped>
.integration_container {
	width: 100%;
	height: 97%;
	position: relative;
	min-height: 510px;
	transition: all 0s;
}
.integration_container.show_switches {
	min-height: 580px;
}
.integration {
	position: relative;
}
.integration .field_name {
	min-width: 75px;
}
h2.med {
	font-size: 16px;
	font-weight: 600;
	color: #292829;
}
.ac {
	border-radius: 4px !important;
	border-color: #d6ddeb;
}
.ac_card {
	width: 32px;
	height: 32px;
	border-radius: 7px !important;
}
h3.tit {
	color: #5c8df5;
	font-weight: 500;
	font-size: 14px;
}
h5.desc {
	font-size: 12px;
	font-weight: 300;
	color: #464b57;
}
.v-list-item {
	padding: 0px;
}
h3 {
	color: #354052;
	font-size: 16px;
	font-weight: 400;
}
.bottom_actions {
	position: absolute;
	bottom: 12px;
	left: 0px;
	width: 100%;
}
.blk {
	margin-bottom: 60px;
}

.swtch.sml {
	transform: scale(0.86);
	position: relative;
	display: inline-block;
	transform-origin: left;
}
</style>
